
import {
  Button,
  Dialog,
  Select,
  Option,
  Label,
  Form,
  FormItem,
  Input,
  Checkbox,
} from 'element-ui';

import { CheckIcon, InfoIcon, MailIcon, CopyIcon } from 'vue-feather-icons';
import { ShopHelper } from '@/helpers/ShopHelper';

export default {
  data() {
    return {
      step: 1,
      newsletter: {
        email: '',
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.$t('Please input correct email address'),
            trigger: 'blur',
          },
        ],
      },
      readyToShow: false,
      codepromo: null,
      loading: false,
    };
  },
  computed: {
    showed: {
      get() {
        // Never show newsletter modal on order confirmation page
        if (this.$route?.path?.includes('/cart/thanks')) return false;

        const newsletterState = this.$store.state.popups.newsletter;
        const pageCount = newsletterState.pageCount > 5;
        return pageCount && !newsletterState.showed;
      },
      set(val) {
        // this.$store.commit('popups/newsletter/setPageCount', {
        //   $cookies: this.$cookies,
        //   val: 0,
        // });
        this.$store.commit('popups/newsletter/setIsShowed', {
          $cookies: this.$cookies,
          val: val,
        });
      },
    },
  },
  methods: {
    async onSubmit() {
      this.$refs['newsletterForm'].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const shopHelper = new ShopHelper(this.$http, this);
          const response = await shopHelper.newsletterSubscription({
            email: this.newsletter.email,
            languageIsoCode: this.$i18n.locale,
            currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
          });

          if (response.status === 200) {
            this.codepromo = response?.data?.PromoCode;
            this.step++;

            this.$store.commit('popups/newsletter/saveToCoockies', {
              $cookies: this.$cookies,
              val: true,
            });
          }
          this.loading = false;
        } else {
          return false;
        }
      });
    },
    closeDialog() {
      this.showed = true;
    },
    copyPromoCode(text) {
      if (process.client) {
        navigator.clipboard.writeText(text);
        this.$message.info({
          message: text + ' - ' + this.$t('Copied'),
          duration: 1000,
          showClose: true,
        });
      }
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.readyToShow = true;
    // }, 5000);
  },
  components: {
    Button,
    Dialog,
    Select,
    Option,
    Label,
    Form,
    FormItem,
    Input,
    CheckIcon,
    InfoIcon,
    MailIcon,
    Checkbox,
    CopyIcon,
  },
};
